import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {RoutesResolver} from "routes";
import {IAccount, TableSettings} from "features/accounts";

interface Props extends Omit<ListItemsTableProps<
    IAccount & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<IAccount>[]
}

export function AccountsListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}